// extracted by mini-css-extract-plugin
export default {"modalContent":"modalContent__Zjk2N","modalHed":"modalHed__ZDAxZ","modalDek":"modalDek__N2NjZ","modalCtaWrapper":"modalCtaWrapper__MDQ4Y","modalCta":"modalCta__YWE5Y"};